export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.5-1535.08",
  commitId: "f0506c631d54c7ec17ecc349cc743b697f41cb94",
  commitTime: "2026-05-05T15:35:08.000Z",
});
